module.exports = __webpack_public_path__ + "static/media/2-4-3_Spot_UV_Special_02.a06712b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-3_Spot_UV_Special_02.jpg
// module id = 1729
// module chunks = 0